import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

interface BackArrowProps {
  color?: string;
  style?: React.CSSProperties;
}

export const BackArrow = ({ color = RoutalPalette.primary40, style = {} }: BackArrowProps) => {
  return (
    <SvgIcon viewBox="0 0 19 19" style={{ height: `19px`, width: `19px`, fill: `none`, ...style }}>
      <path d="M14.75 9.55896L4.25 9.55896" stroke="#406867" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 14.809L4.25 9.55896L9.5 4.30896" stroke="#406867" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
